"use strict";

function _typeof(obj) {
    "@babel/helpers - typeof";
    return (
        (_typeof =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (obj) {
                      return typeof obj;
                  }
                : function (obj) {
                      return obj &&
                          "function" == typeof Symbol &&
                          obj.constructor === Symbol &&
                          obj !== Symbol.prototype
                          ? "symbol"
                          : typeof obj;
                  }),
        _typeof(obj)
    );
}

Object.defineProperty(exports, "__esModule", {
    value: true,
});
exports.Switch = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _defineProperty2, _defineProperty3;

var _excluded = [
    "backgroundActive",
    "backgroundInactive",
    "circleActiveColor",
    "circleInActiveColor",
    "activeText",
    "inActiveText",
    "circleSize",
    "containerStyle",
    "activeTextStyle",
    "inactiveTextStyle",
    "barHeight",
    "circleBorderInactiveColor",
    "circleBorderActiveColor",
    "circleBorderWidth",
    "innerCircleStyle",
    "outerCircleStyle",
    "renderActiveText",
    "renderInActiveText",
    "renderInsideCircle",
    "switchWidthMultiplier",
    "switchBorderRadius",
    "value",
];

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(
        nodeInterop,
    ) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (
        obj === null ||
        (_typeof(obj) !== "object" && typeof obj !== "function")
    ) {
        return { default: obj };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor =
        Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
        if (
            key !== "default" &&
            Object.prototype.hasOwnProperty.call(obj, key)
        ) {
            var desc = hasPropertyDescriptor
                ? Object.getOwnPropertyDescriptor(obj, key)
                : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj["default"] = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}

function _extends() {
    _extends = Object.assign
        ? Object.assign.bind()
        : function (target) {
              for (var i = 1; i < arguments.length; i++) {
                  var source = arguments[i];
                  for (var key in source) {
                      if (Object.prototype.hasOwnProperty.call(source, key)) {
                          target[key] = source[key];
                      }
                  }
              }
              return target;
          };
    return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for (i = 0; i < sourceSymbolKeys.length; i++) {
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key))
                continue;
            target[key] = source[key];
        }
    }
    return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}

function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", { writable: false });
    return Constructor;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError(
            "Super expression must either be null or a function",
        );
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: { value: subClass, writable: true, configurable: true },
    });
    Object.defineProperty(subClass, "prototype", { writable: false });
    if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf
        ? Object.setPrototypeOf.bind()
        : function _setPrototypeOf(o, p) {
              o.__proto__ = p;
              return o;
          };
    return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    } else if (call !== void 0) {
        throw new TypeError(
            "Derived constructors may only return object or undefined",
        );
    }
    return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called",
        );
    }
    return self;
}

function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(
            Reflect.construct(Boolean, [], function () {}),
        );
        return true;
    } catch (e) {
        return false;
    }
}

function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf
        ? Object.getPrototypeOf.bind()
        : function _getPrototypeOf(o) {
              return o.__proto__ || Object.getPrototypeOf(o);
          };
    return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true,
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var Switch = /*#__PURE__*/ (function (_Component) {
    _inherits(Switch, _Component);

    var _super = _createSuper(Switch);

    function Switch(props, context) {
        var _this;

        _classCallCheck(this, Switch);

        _this = _super.call(this, props, context);

        _defineProperty(
            _assertThisInitialized(_this),
            "handleSwitch",
            function () {
                var value = _this.state.value;
                var _this$props = _this.props,
                    onValueChange = _this$props.onValueChange,
                    disabled = _this$props.disabled,
                    changeValueImmediately = _this$props.changeValueImmediately,
                    propValue = _this$props.value;

                if (disabled) {
                    return;
                }

                if (_this.props.value === _this.state.value) {
                    onValueChange(!_this.state.value);
                    return;
                }

                if (changeValueImmediately) {
                    _this.animateSwitch(!propValue);

                    onValueChange(!propValue);
                } else {
                    _this.animateSwitch(!value, function () {
                        return _this.setState(
                            {
                                value: !value,
                            },
                            function () {
                                return onValueChange(_this.state.value);
                            },
                        );
                    });
                }
            },
        );

        _defineProperty(
            _assertThisInitialized(_this),
            "animateSwitch",
            function (value) {
                var cb =
                    arguments.length > 1 && arguments[1] !== undefined
                        ? arguments[1]
                        : function () {};

                _reactNative.Animated.parallel([
                    _reactNative.Animated.spring(_this.state.transformSwitch, {
                        toValue: value
                            ? _this.props.circleSize / _this.props.switchLeftPx
                            : -_this.props.circleSize /
                              _this.props.switchRightPx,
                        useNativeDriver: false,
                    }),
                    _reactNative.Animated.timing(_this.state.backgroundColor, {
                        toValue: value ? 75 : -75,
                        duration: 200,
                        useNativeDriver: false,
                    }),
                    _reactNative.Animated.timing(_this.state.circleColor, {
                        toValue: value ? 75 : -75,
                        duration: 200,
                        useNativeDriver: false,
                    }),
                    _reactNative.Animated.timing(
                        _this.state.circleBorderColor,
                        {
                            toValue: value ? 75 : -75,
                            duration: 200,
                            useNativeDriver: false,
                        },
                    ),
                ]).start(cb);
            },
        );

        _this.state = {
            value: props.value,
            transformSwitch: new _reactNative.Animated.Value(
                props.value
                    ? props.circleSize / props.switchLeftPx
                    : -props.circleSize / props.switchRightPx,
            ),
            backgroundColor: new _reactNative.Animated.Value(
                props.value ? 75 : -75,
            ),
            circleColor: new _reactNative.Animated.Value(
                props.value ? 75 : -75,
            ),
            circleBorderColor: new _reactNative.Animated.Value(
                props.value ? 75 : -75,
            ),
        };
        return _this;
    }

    _createClass(Switch, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this2 = this;

                var _this$props2 = this.props,
                    value = _this$props2.value,
                    disabled = _this$props2.disabled;

                if (prevProps.value === value) {
                    return;
                }

                if (prevProps.disabled && disabled === prevProps.disabled) {
                    return;
                }

                this.animateSwitch(value, function () {
                    return _this2.setState({
                        value: value,
                    });
                });
            },
        },
        {
            key: "render",
            value: function render() {
                var _this$state = this.state,
                    transformSwitch = _this$state.transformSwitch,
                    backgroundColor = _this$state.backgroundColor,
                    circleColor = _this$state.circleColor,
                    circleBorderColor = _this$state.circleBorderColor;

                var _this$props3 = this.props,
                    backgroundActive = _this$props3.backgroundActive,
                    backgroundInactive = _this$props3.backgroundInactive,
                    circleActiveColor = _this$props3.circleActiveColor,
                    circleInActiveColor = _this$props3.circleInActiveColor,
                    activeText = _this$props3.activeText,
                    inActiveText = _this$props3.inActiveText,
                    circleSize = _this$props3.circleSize,
                    containerStyle = _this$props3.containerStyle,
                    activeTextStyle = _this$props3.activeTextStyle,
                    inactiveTextStyle = _this$props3.inactiveTextStyle,
                    barHeight = _this$props3.barHeight,
                    circleBorderInactiveColor =
                        _this$props3.circleBorderInactiveColor,
                    circleBorderActiveColor =
                        _this$props3.circleBorderActiveColor,
                    circleBorderWidth = _this$props3.circleBorderWidth,
                    innerCircleStyle = _this$props3.innerCircleStyle,
                    outerCircleStyle = _this$props3.outerCircleStyle,
                    renderActiveText = _this$props3.renderActiveText,
                    renderInActiveText = _this$props3.renderInActiveText,
                    renderInsideCircle = _this$props3.renderInsideCircle,
                    switchWidthMultiplier = _this$props3.switchWidthMultiplier,
                    switchBorderRadius = _this$props3.switchBorderRadius,
                    value = _this$props3.value,
                    restProps = _objectWithoutProperties(
                        _this$props3,
                        _excluded,
                    );

                var interpolatedColorAnimation = backgroundColor.interpolate({
                    inputRange: [-75, 75],
                    outputRange: [backgroundInactive, backgroundActive],
                });
                var interpolatedCircleColor = circleColor.interpolate({
                    inputRange: [-75, 75],
                    outputRange: [circleInActiveColor, circleActiveColor],
                });
                var interpolatedCircleBorderColor =
                    circleBorderColor.interpolate({
                        inputRange: [-75, 75],
                        outputRange: [
                            circleBorderInactiveColor,
                            circleBorderActiveColor,
                        ],
                    });
                return /*#__PURE__*/ _react["default"].createElement(
                    _reactNative.TouchableWithoutFeedback,
                    _extends(
                        {
                            onPress: this.handleSwitch,
                        },
                        restProps,
                    ),
                    /*#__PURE__*/ _react["default"].createElement(
                        _reactNative.Animated.View,
                        {
                            style: [
                                styles.container,
                                containerStyle,
                                {
                                    backgroundColor: interpolatedColorAnimation,
                                    width: circleSize * switchWidthMultiplier,
                                    height: barHeight || circleSize,
                                    borderRadius:
                                        switchBorderRadius || circleSize,
                                },
                            ],
                        },
                        /*#__PURE__*/ _react["default"].createElement(
                            _reactNative.Animated.View,
                            {
                                style: [
                                    styles.animatedContainer,
                                    {
                                        left: transformSwitch,
                                        width:
                                            circleSize * switchWidthMultiplier,
                                    },
                                    outerCircleStyle,
                                ],
                            },
                            value &&
                                renderActiveText &&
                                /*#__PURE__*/ _react["default"].createElement(
                                    _reactNative.Text,
                                    {
                                        style: [
                                            styles.text,
                                            styles.paddingRight,
                                            activeTextStyle,
                                        ],
                                    },
                                    activeText,
                                ),
                            /*#__PURE__*/ _react["default"].createElement(
                                _reactNative.Animated.View,
                                {
                                    style: [
                                        styles.circle,
                                        {
                                            borderWidth: circleBorderWidth,
                                            borderColor:
                                                interpolatedCircleBorderColor,
                                            backgroundColor:
                                                interpolatedCircleColor,
                                            width: circleSize,
                                            height: circleSize,
                                            borderRadius: circleSize / 2,
                                        },
                                        innerCircleStyle,
                                    ],
                                },
                                renderInsideCircle(),
                            ),
                            !value &&
                                renderInActiveText &&
                                /*#__PURE__*/ _react["default"].createElement(
                                    _reactNative.Text,
                                    {
                                        style: [
                                            styles.text,
                                            styles.paddingLeft,
                                            inactiveTextStyle,
                                        ],
                                    },
                                    inActiveText,
                                ),
                        ),
                    ),
                );
            },
        },
    ]);

    return Switch;
})(_react.Component);

exports.Switch = Switch;

_defineProperty(
    Switch,
    "propTypes",
    ((_defineProperty2 = {
        onValueChange: _propTypes["default"].func,
        disabled: _propTypes["default"].bool,
        activeText: _propTypes["default"].string,
        inActiveText: _propTypes["default"].string,
        backgroundActive: _propTypes["default"].string,
        backgroundInactive: _propTypes["default"].string,
        value: _propTypes["default"].bool,
        circleActiveColor: _propTypes["default"].string,
        circleInActiveColor: _propTypes["default"].string,
        circleSize: _propTypes["default"].number,
        circleBorderActiveColor: _propTypes["default"].string,
        circleBorderInactiveColor: _propTypes["default"].string,
        activeTextStyle: _propTypes["default"].object,
        inactiveTextStyle: _propTypes["default"].object,
        containerStyle: _propTypes["default"].object,
        barHeight: _propTypes["default"].number,
        circleBorderWidth: _propTypes["default"].number,
        innerCircleStyle: _propTypes["default"].object,
        renderInsideCircle: _propTypes["default"].func,
        changeValueImmediately: _propTypes["default"].bool,
    }),
    _defineProperty(
        _defineProperty2,
        "innerCircleStyle",
        _propTypes["default"].object,
    ),
    _defineProperty(
        _defineProperty2,
        "outerCircleStyle",
        _propTypes["default"].object,
    ),
    _defineProperty(
        _defineProperty2,
        "renderActiveText",
        _propTypes["default"].bool,
    ),
    _defineProperty(
        _defineProperty2,
        "renderInActiveText",
        _propTypes["default"].bool,
    ),
    _defineProperty(
        _defineProperty2,
        "switchLeftPx",
        _propTypes["default"].number,
    ),
    _defineProperty(
        _defineProperty2,
        "switchRightPx",
        _propTypes["default"].number,
    ),
    _defineProperty(
        _defineProperty2,
        "switchWidthMultiplier",
        _propTypes["default"].number,
    ),
    _defineProperty(
        _defineProperty2,
        "switchBorderRadius",
        _propTypes["default"].number,
    ),
    _defineProperty2),
);

_defineProperty(
    Switch,
    "defaultProps",
    ((_defineProperty3 = {
        value: false,
        onValueChange: function onValueChange() {
            return null;
        },
        renderInsideCircle: function renderInsideCircle() {
            return null;
        },
        innerCircleStyle: {},
        disabled: false,
        activeText: "On",
        inActiveText: "Off",
        backgroundActive: "green",
        backgroundInactive: "gray",
        circleActiveColor: "white",
        circleInActiveColor: "white",
        circleBorderActiveColor: "rgb(100, 100, 100)",
        circleBorderInactiveColor: "rgb(80, 80, 80)",
        circleSize: 30,
        barHeight: null,
        circleBorderWidth: 1,
        changeValueImmediately: true,
    }),
    _defineProperty(_defineProperty3, "innerCircleStyle", {
        alignItems: "center",
        justifyContent: "center",
    }),
    _defineProperty(_defineProperty3, "outerCircleStyle", {}),
    _defineProperty(_defineProperty3, "renderActiveText", true),
    _defineProperty(_defineProperty3, "renderInActiveText", true),
    _defineProperty(_defineProperty3, "switchLeftPx", 2),
    _defineProperty(_defineProperty3, "switchRightPx", 2),
    _defineProperty(_defineProperty3, "switchWidthMultiplier", 2),
    _defineProperty(_defineProperty3, "switchBorderRadius", null),
    _defineProperty(_defineProperty3, "testID", null),
    _defineProperty3),
);

var styles = _reactNative.StyleSheet.create({
    container: {
        width: 71,
        height: 30,
        borderRadius: 30,
        backgroundColor: "black",
    },
    animatedContainer: {
        flex: 1,
        width: 78,
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
    },
    circle: {
        width: 30,
        height: 30,
        borderRadius: 15,
        backgroundColor: "white",
    },
    text: {
        color: "white",
        backgroundColor: "transparent",
    },
    paddingRight: {
        paddingRight: 5,
    },
    paddingLeft: {
        paddingLeft: 5,
    },
});
